import type {JoyIconsId} from '@maltjoy/icons';

export type EditorJsonNode = {
    type?: string;
    text?: string;
    attrs?: Record<string, unknown>;
    content?: EditorJsonNode[];
};

export type PortfolioEditorItemEvent =
    | 'trigger-image-upload'
    | 'open-video-dialog'
    | 'insert-divider'
    | 'insert-table'
    | 'insert-blockquote'
    | 'insert-heading1'
    | 'insert-heading2';

type PortfolioEditorItem = {label: string; icon?: JoyIconsId; event: PortfolioEditorItemEvent};

export const PORTFOLIO_EDITOR_ITEMS: PortfolioEditorItem[] = [
    {label: 'Image', icon: 'image', event: 'trigger-image-upload'},
    {label: 'Video', icon: 'play', event: 'open-video-dialog'},
    {label: 'Divider', icon: 'minus', event: 'insert-divider'},
    {label: 'Table', icon: 'grid', event: 'insert-table'},
    {label: 'Quote', icon: 'quote', event: 'insert-blockquote'},
    {label: 'Heading 1', event: 'insert-heading1'},
    {label: 'Heading 2', event: 'insert-heading2'},
];
